<div
  class="dashboard"
  data-cy="dashboard-wrapper">
  <ng-container *ngIf="user">
    <mat-card
      class="mat-elevation-z2"
      *ngFor="let poolRequest of user.poolRequests; trackBy: trackPoolRequest"
      [attr.data-cy]="'pool-request-' + poolRequest.customerId">
      <mat-card-title>
        {{
          (loggedInRole$ | async) === roleEnum.POOL
            ? ("poolRequestTitle" | i18n)
            : ("dispoRequestTitle" | i18n)
        }}
      </mat-card-title>
      <mat-card-content>
        {{ poolRequest.displayName }}
        {{
          (loggedInRole$ | async) === roleEnum.POOL
            ? ("poolRequestText" | i18n)
            : ("dispoRequestText" | i18n)
        }}
      </mat-card-content>
      <mat-card-actions>
        <button
          type="button"
          mat-button
          data-cy="deny-pool-request-button"
          (click)="denyOrAcceptPoolRequest(poolRequest.customerId, false)">
          {{ ("decline" | i18n) || "decline" | uppercase }}
        </button>
        <button
          type="button"
          mat-button
          data-cy="accept-pool-request-button"
          (click)="denyOrAcceptPoolRequest(poolRequest.customerId, true)">
          {{ ("confirm" | i18n) || "confirm" | uppercase }}
        </button>
      </mat-card-actions>
    </mat-card>
  </ng-container>

  <ng-container *ngIf="user">
    <mat-card
      class="mat-elevation-z2"
      data-cy="organisation-request-card"
      *ngFor="let organisationRequest of organisationRequests | async">
      <mat-card-title>
        {{
          ("organisationRequestTitle" | i18n) || "new organisation" | titlecase
        }}
      </mat-card-title>
      <mat-card-subtitle>{{ organisationRequest.title }}</mat-card-subtitle>

      <mat-card-content>
        <p>
          <b>{{
            ("organisationRequestText" | i18n) ||
              "Do you want to receive job requests for this organisation?"
          }}</b>
        </p>
        <div
          class="sm"
          [innerHTML]="organisationRequest.description"></div>
        <a
          [href]="organisationRequest.url"
          target="_blank"
          >{{ ("moreLink" | i18n) || "goto website" | titlecase }}</a
        >
      </mat-card-content>

      <mat-card-actions>
        <button
          type="button"
          mat-button
          data-cy="deny-organisation-request-button"
          (click)="
            denyOrAcceptOrganisationRequest(organisationRequest._id, false)
          ">
          {{ ("decline" | i18n) || "decline" | uppercase }}
        </button>
        <button
          type="button"
          mat-button
          data-cy="accept-organisation-request-button"
          (click)="
            denyOrAcceptOrganisationRequest(organisationRequest._id, true)
          ">
          {{ ("confirm" | i18n) || "confirm" | uppercase }}
        </button>
      </mat-card-actions>
    </mat-card>
  </ng-container>

  <ng-container
    *ngIf="
      isPooler &&
      pendingTimetrackingJob &&
      pendingTimetrackingJob._id !== nextJob?._id
    ">
    <h1>{{ ("pendingTimetrackingJobs" | i18n) || "Offene Zeiterfassung" }}</h1>
    <app-pooler-job-list-item
      [attr.data-cy]="
        'pending-timetracking-job-list-item-' + pendingTimetrackingJob._id
      "
      class="dashboard-job-list-item"
      [withDate]="true"
      [job]="pendingTimetrackingJob"></app-pooler-job-list-item>
  </ng-container>

  <ng-container *ngIf="isPooler">
    <h1>{{ ("nextJob" | i18n) || "Nächster Dienst" }}</h1>
    <div data-cy="upcoming-jobs-list">
      <ng-container *ngIf="nextJob">
        <app-pooler-job-list-item
          [withDate]="true"
          class="dashboard-job-list-item"
          [attr.data-cy]="'upcoming-job-list-item-id-' + nextJob._id"
          [job]="nextJob"></app-pooler-job-list-item>
      </ng-container>
      <ng-container *ngIf="!nextJob">
        <p>{{ ("noJobFound" | i18n) || "Kein Dienst gefunden" }}</p>
      </ng-container>
    </div>
    <div style="text-align: center">
      <a
        mat-button
        [queryParams]="{ state: poolerJobStatusEnum.CLOSED }"
        routerLink="/jobs">
        <span>{{ ("showAll" | i18n) || "Alle anzeigen" | uppercase }}</span>
        <mat-icon svgIcon="chevron-right"></mat-icon>
      </a>
    </div>
  </ng-container>

  <ng-container
    *ngIf="user && user.role === roleEnum.POOL && user.hasEmployments">
    <h1 class="dashboard-title">
      {{ ("nextEmployment" | i18n) || "Nächster Einsatz" }}
    </h1>
    <ng-container *ngIf="nextEmployment">
      <app-pooler-employment-list-item
        [employment]="nextEmployment"
        [currentUser]="user"
        data-cy="upcoming-employment"></app-pooler-employment-list-item>
    </ng-container>
    <ng-container *ngIf="!nextEmployment">
      <p>{{ ("noEmploymentFound" | i18n) || "Kein Einsatz gefunden" }}</p>
    </ng-container>
    <div style="text-align: center">
      <a
        mat-button
        [queryParams]="{ tab: poolerEmploymentStatusEnum.BOOKED }"
        routerLink="/temp-work/pooler-employments">
        <span>{{ ("showAll" | i18n) || "Alle anzeigen" | uppercase }}</span>
        <mat-icon svgIcon="chevron-right"></mat-icon>
      </a>
    </div>
  </ng-container>

  <ng-container *ngIf="isPooler">
    <div class="dashboard-jobs-list-header">
      <h1 class="dashboard-title">
        {{ ("newestRequests" | i18n) || "Neueste Anfragen" }}
      </h1>
      <app-hide-all-jobs-button></app-hide-all-jobs-button>
    </div>
    <div
      data-cy="new-jobs-list"
      class="dashboard-jobs-list">
      <app-pooler-job-list-item
        class="dashboard-job-list-item"
        *ngFor="let job of newJobs | async; trackJob"
        data-cy="job-list-item"
        [withDate]="true"
        class="dashboard-job-list-item"
        [job]="job"></app-pooler-job-list-item>
    </div>
    <ng-container *ngIf="poolerUser$ | async as pooler">
      <app-pooler-employment-list-item
        *ngFor="let employment of newEmployments | async; trackBy: trackById"
        [employment]="employment"
        [currentUser]="pooler">
      </app-pooler-employment-list-item>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="!isPooler && user">
    <h1 class="dashboard-title">
      {{ ("actionRequiringJobs" | i18n) || "Aktion erfordernde Dienste" }}
    </h1>
    <div data-cy="action-required-jobs-list">
      <app-dispo-job-list-item
        *ngFor="let job of newJobs | async; trackJob"
        data-cy="job-list-item"
        class="dashboard-job-list-item"
        [withDate]="true"
        [job]="job"
        [loggedInUser]="user.role === roleEnum.DISPO ? user : undefined"
        [routerLink]="'/jobs/' + job._id"></app-dispo-job-list-item>
    </div>
    <app-employment-list-item
      *ngFor="let employment of newEmployments | async; trackBy: trackById"
      [routerLink]="'/temp-work/employments/' + employment._id"
      [employment]="employment"></app-employment-list-item>
  </ng-container>
  <ng-container>
    <div class="show-all-links">
      <a
        mat-button
        [queryParams]="{
          range: 'ALL',
          state: isPooler ? poolerJobStatusEnum.NEW : jobStatusEnum.OPEN
        }"
        routerLink="/jobs">
        <span>{{
          ("showAllJobs" | i18n) || "Alle Dienste anzeigen" | uppercase
        }}</span>
        <mat-icon svgIcon="chevron-right"></mat-icon>
      </a>
      <a
        *ngIf="user && user.role === roleEnum.POOL && user.hasEmployments"
        class="more-employments-button"
        mat-button
        [queryParams]="{
          tab: poolerEmploymentStatusEnum.NEW
        }"
        routerLink="/temp-work/pooler-employments">
        <span>{{
          ("showAllEmployments" | i18n) || "Alle Einsätze anzeigen" | uppercase
        }}</span>
        <mat-icon svgIcon="chevron-right"></mat-icon>
      </a>
      <a
        *ngIf="
          user &&
          user.role !== roleEnum.POOL &&
          (dispoCustomer?.hasEmployments || dispoCustomer?.enableEmployments)
        "
        class="more-employments-button"
        mat-button
        [queryParams]="{
          tab: dispoEmploymentStatusEnum.OPEN
        }"
        routerLink="/temp-work/employments">
        <span>{{
          ("showAllEmployments" | i18n) || "Alle Einsätze anzeigen" | uppercase
        }}</span>
        <mat-icon svgIcon="chevron-right"></mat-icon>
      </a>
    </div>
  </ng-container>

  <ng-container *ngIf="isPooler">
    <h1 class="dashboard-title">
      {{ ("matchingOffers" | i18n) || "Passende Angebote" }}
    </h1>
    <div
      class="possible-jobs-row"
      #possibleWorkElement
      *ngIf="
        (poolerUser$ | async)?.hasEmployments &&
        (poolerUser$ | async)?.hasJobAssignments
      ">
      <div class="tabs matching-offers-tabs">
        <nav
          mat-tab-nav-bar
          class="themed-tab-nav">
          <a
            mat-tab-link
            *ngFor="let tab of possibleJobsTabs"
            (click)="switchPossibleJobsTab(tab.value, possibleWorkElement)"
            (touchstart)="switchPossibleJobsTab(tab.value, possibleWorkElement)"
            [active]="(possibleJobsTab$ | async) == tab.value"
            [attr.data-cy]="'state-' + tab.value + '-toggle-button'">
            <mat-icon
              [svgIcon]="tab.svgIcon"
              class="size-20"></mat-icon>
            {{ tab.label | i18n | titlecase }}
          </a>
        </nav>
      </div>
    </div>
    <ng-container *ngIf="(possibleJobsTab$ | async) === 'possible-jobs'">
      <div
        *ngIf="(possibleJobsTab$ | async) === 'possible-jobs'"
        class="own-availability-checkbox">
        <mat-checkbox
          (change)="toggleCheckOwnAvailability()"
          id="own-availability-checkbox"
          data-cy="check-own-availability-checkbox">
          {{
            ("checkOwnAvailability" | i18n) ||
              "Eigene Verfügbarkeit berücksichtigen"
          }}
        </mat-checkbox>
      </div>
      <div data-cy="possible-jobs-list">
        <ng-container *ngIf="(possibleJobs$ | async)?.length; else noJobsFound">
          <app-pooler-job-list-item
            *ngFor="let job of possibleJobs$ | async; trackBy: trackById"
            class="dashboard-job-list-item"
            [withDate]="true"
            [job]="job"
            [isPossibleJob]="true"></app-pooler-job-list-item>
        </ng-container>
        <ng-template #noJobsFound>
          {{ "noMatchingJobs" | i18n }}
        </ng-template>
      </div>
    </ng-container>
    <div
      data-cy="possible-employments-list"
      *ngIf="(possibleJobsTab$ | async) === 'possible-employments'">
      <ng-container *ngIf="userService.readyPooler$ | async as currentUser">
        <ng-container
          *ngIf="
            (possibleEmployments$ | async)?.length;
            else noEmploymentsFound
          ">
          <app-pooler-employment-list-item
            *ngFor="
              let employment of possibleEmployments$ | async;
              trackBy: trackById
            "
            [employment]="employment"
            [isSelfSignIn]="true"
            [currentUser]="currentUser"></app-pooler-employment-list-item>
        </ng-container>
        <ng-template #noEmploymentsFound>
          {{ "noMatchingEmployments" | i18n }}
        </ng-template>
      </ng-container>
    </div>
  </ng-container>
</div>
